import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

/**
 * ComparisonBlock
 *  - The block renders actively comparing components
 */
const TEXT = 'text';
export function ComparisonBlock(props) {

  const renderSection = (section) => (
    <div className='comparing_item'>
      {React.cloneElement(section.component)}
    </div>
  );

  return (
    <div className='comparisonBlock'>
      <div className='comparisonBlock_left'>
        {renderSection(props.leftSection)}
      </div>
      <div className='comparisonBlock_right'>
        {renderSection(props.rightSection)}
      </div>
    </div>
  );
}

ComparisonBlock.propTypes = {
  /**
   * Data for rendering the left compare block
   */
  leftSection: PropTypes.shape({
    /**
     * Type of comparing component
     */
    type: PropTypes.string,
    /**
     * component to be rendered at left section
     */
    component: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  }),
  /**
   * Data for rendering the left compare block
   */
  rightSection: PropTypes.shape({
    /**
     * Type of comparing component
     */
    type: PropTypes.string,
    /**
     * component to be rendered at right section
     */
    component: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  }),
};

ComparisonBlock.defaultProps = {
  leftSection: {
    type: 'text',
    component: <h5>left</h5>,
  },
  rightSection: {
    type: 'text',
    component: <h5>right</h5>,
  },
};
